module.exports = __webpack_public_path__ + "img/telegram.8a9a3d9c.svg";